import type { ProsjektBrukerRolle } from '@klp/formgenerator/interfaces';
import { useCallback } from 'react';
import i18n from 'i18next';

export const useRoleMapping = () => {
    const handleMapping = useCallback((role?: ProsjektBrukerRolle | string) => {
        if (!role) return undefined;

        return role
            .split(',')
            .map((r) => i18n.t(`prosjekt.table.roller.${r.trim()}`))
            .join(', ');
    }, []);

    return { handleMapping };
};
